import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

const split = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
};

export const OfferCountdown = ({ plan, className = "" }) => {
  const [now, setNow] = useState(Date.now());
  const start = plan.offer_start ? new Date(plan.offer_start).getTime() : null;
  const end = plan.offer_end ? new Date(plan.offer_end).getTime() : null;

  useEffect(() => {
    if (!end) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [end]);

  if (!end || Number.isNaN(end) || now > end) return null;
  const upcoming = start && now < start;
  const t = split((upcoming ? start : end) - now);
  const urgent = !upcoming && end - now < 24 * 3600 * 1000;

  return (
    <div
      data-testid={`offer-countdown-${plan.id}`}
      className={`flex items-center gap-2 border px-3 py-1.5 backdrop-blur-md ${
        urgent ? "bg-red-600/80 border-red-400/50 text-white" : "bg-black/70 border-[#D4AF37]/40 text-[#D4AF37]"
      } ${className}`}
    >
      <Clock size={12} className={urgent ? "animate-pulse" : ""} />
      <span className="font-accent text-[9px] tracking-[0.2em] uppercase">{upcoming ? "Offer starts in" : "Offer ends in"}</span>
      <span className="font-accent text-[11px] tabular-nums tracking-wider" data-testid={`offer-countdown-time-${plan.id}`}>
        {t.d > 0 && `${t.d}d `}{pad(t.h)}:{pad(t.m)}:{pad(t.s)}
      </span>
    </div>
  );
};
